<template>

<div class="spaces">

    <app-icon icon="loading" v-if="is.loading && !is.initialised" class="spaces-loading" />

    <app-content-body v-if="is.initialised" :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no spaces found.">

		<app-table v-for="day in references.days" :key="day.value">

			<app-table-head :no-gap="true" :layout="layout">

				<app-table-column />
				<app-table-column border="left" :text="day.text" />

			</app-table-head>

			<app-table-body>

				<app-table-row :no-gap="true" :no-click="true" :no-hover="true" :layout="layout" key="times">

					<app-table-cell-text />
					<app-table-cell-times border="left" :space="item.id" :day="day.value" :start="references.room.schedule.start" :end="references.room.schedule.end" :times="references.times" />

				</app-table-row>

				<app-table-row :no-gap="true" :no-click="true" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-text :text="item.name" :subtext="seatCount(item)" />
					<app-table-cell-schedule border="left" :space="item.id" :day="day.value" :scheduled="references.scheduled" :start="references.room.schedule.start" :end="references.room.schedule.end" :times="references.times" />

				</app-table-row>

			</app-table-body>

		</app-table>

	</app-content-body>
        
</div>
	
</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	props: ['item'],

    data: function() {

		return {
            inline: true,
			scrolling: false,
			endpoint: '../register/block/spaces',
			references: {
				days: [],
                times: [],
                room: {},
				scheduled: []
			},
            pagination: {
				perpage: 10000,
				page: 1
			},
            params: {
                block: false
            }
		}

	},

	computed: {

		layout: function() {
		
			var layout = ['64px']

			layout.push('1fr')

			return layout.join(' ')

		}
	
	},

    methods: {

        setupParams: function() {

            this.params.block = this.item.id

        },
	
		seatCount: function(item) {
		
			return (item.seats === 0) ? 'Unlimited' : item.seats.toString() + ' seat' + ((item.seats > 1) ? 's' : '')

		}
    
    }

}

</script>

<style scoped>

.spaces {
    height: auto;
    padding: 0px;
    margin: 20px;
    border: 1px solid #eee;
    border-radius: 4px;
    overflow: auto;
    min-height: 100px;
}

.is-desktop .spaces {
    max-height: 640px;
}

.spaces >>> .body {
    padding: 0px!important;
}

.spaces-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    font-size: 32px;
    color: #ffbe7a;
    margin-top: -32px;
    margin-left: -32px;
}

.spaces >>> .row {
    padding-right: 0px;
}

</style>